var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleRedesign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.54234 5.50671C3.09726 4.4024 3.94822 3.47408 5.00021 2.82542C6.05219 2.17676 7.26378 1.83329 8.49967 1.83337C10.2963 1.83337 11.8057 2.49404 12.9597 3.57004L11.0483 5.48204C10.357 4.82137 9.47834 4.48471 8.49967 4.48471C6.76301 4.48471 5.29301 5.65804 4.76968 7.23337C4.63634 7.63337 4.56034 8.06004 4.56034 8.50004C4.56034 8.94004 4.63634 9.36671 4.76968 9.76671C5.29367 11.3427 6.76301 12.5154 8.49967 12.5154C9.39634 12.5154 10.1597 12.2787 10.757 11.8787C11.1033 11.6507 11.3998 11.3549 11.6285 11.009C11.8572 10.6632 12.0134 10.2746 12.0877 9.86671H8.49967V7.28804H14.7783C14.857 7.72404 14.8997 8.17871 14.8997 8.65137C14.8997 10.682 14.173 12.3914 12.9117 13.5514C11.809 14.57 10.2997 15.1667 8.49967 15.1667C7.6241 15.1671 6.75703 14.9949 5.94804 14.66C5.13904 14.325 4.40398 13.834 3.78485 13.2149C3.16572 12.5957 2.67467 11.8607 2.33976 11.0517C2.00486 10.2427 1.83266 9.37562 1.83301 8.50004C1.83301 7.42404 2.09034 6.40671 2.54234 5.50671Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleRedesign);
export default __webpack_public_path__ + "static/media/google-redesign.0974561d91f213e7c84673d9ca14a916.svg";
export { ForwardRef as ReactComponent };